<template>
  <div class="m-0 p-0" :style="styles">
    <ValidationProvider v-if="validation" :rules="validation" :vid="fieldId" v-slot="{ errors }" :name="name">
      <div class="textInputWrapper form-group">
        <input
          :type="inputType"
          class="form-control textInput"
          :class="{'is-invalid': errors.length}"
          :value="text == '' ? value : text"
          @input="updateValue($event.target.value)"
          ref="input"
          :name="label"
          :id="name"
          required
        />
        <img
          v-if="errors.length"
          class="error_min inputError"
          src="../../assets/icons/risk-icon.svg"
          height="18px"
          width="18px"
          alt
        />
        <span v-if="!text" class="floating-label" :class="{'slideUp': slideUp}">
          <span v-if="errors.length" class="validation-error">{{errors[0]}}</span>
          <span v-else>{{ $t(label) }} <span v-if="validation.includes('required')">*</span></span>
        </span>
        <span v-if="errors.length && text" class="validation-error">{{errors[0]}}</span>
        <img v-if="!errors.length && text" class="inputIcon checkIcon" src="/assets/svg/check.svg" height="25px" width="25px" alt="check" />
      </div>

    </ValidationProvider>
    <div class="m-0 p-0" v-else>
      <div class="textInputWrapper form-group">
        <input
          type="text"
          class="form-control textInput"
          :value="value"
          @input="updateValue($event.target.value)"
          ref="input"
          :name="name"
          :id="name"
          :style="styles"
          required
        />
         <img
          class="add_min inputAdd"
          src="../../assets/icons/add.svg"
          alt
        />
        <span class="floating-label">{{label}} <span v-if="required" style="color:#450C10">*</span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "text-input",
  props: {
    name: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: "text"
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    text: {
      type: String,
      default: ""
    },
    validation: {
      type: String
    },
    value: {
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    fieldId: {
      type: String,
      required: true
    },
    addInput: {
      type: String
    },
    required: {
      type: Boolean
    },
    customError: {
      type: Boolean
    },
    slideUp: {
      type: Boolean
    },
    errorMessage: {
      type: Object,
      default: () => {
        return {
          'email': 'Het veld e-mail is verplicht',
          'firstName': 'Het veld Voornaam is verplicht',
          'lastName': 'Het veld Achternaam is verplicht',
          'City': 'Het veld stad is verplicht'
        }
      }
    }

  },
  methods: {
    updateValue (val) {
      this.$emit("component-updated", {
        text: val,
        slideUp:!!val
      });
      this.$emit("input", val);
    }
  },
  mounted () {
  }
};
</script>

<style scoped lang="scss">
$medium: 800px;

.textInputWrapper {
  position: relative;
  margin: 5px;
  .error_min {
    width: 16px;
  }
  .inputIcon {
    position: absolute;
    right: 10px;
    top: 30%;
  }
  .inputError {
    position: absolute;
    top: 12px;
    right: 10px;
  }
}
.textInputWrapper .textInput {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  height: 50px;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  color: #000;
}
.textInputWrapper .floating-label {
  width: 100%;
  margin-bottom: 10px;
  position: absolute;
  top: 50%;
  left: 12px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  @media (max-width: 767px) {
    font-size: 12px;
    line-height: 15px;
  }
}
.textInputWrapper input:focus ~ .floating-label {
  transform: translateY(-135%) scale(0.7);
}

.slideUp {
  transform: translateY(-135%) scale(0.7) !important;
}

.textInputWrapper input:disabled {
  background-color: #c1c1c1;
}
</style>
